import { render } from "./App.vue?vue&type=template&id=0f3b5f57"
const script = {}

import exportComponent from "/usr/local/www/sites/liveportrait_v2/other_sites/karolg.liveportrait.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__